import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";

const SettingsViewHandler = ({
  selectedView,
  changeView
}) => {

  const company = useSelector(state => state.company);

  return (
    <div className="controllersContainer">
      <div
        className={selectedView === "edit" ? "iconTypeGridForm left active" : "iconTypeGridForm left"}
        onClick={() => changeView("edit")}
        style={{borderRadius: company.companies && company.hasMoreItems && "20px"}}
      >
        <FontAwesomeIcon
          icon={["fas", "edit"]}
          style={{
            fontSize: 14,
            marginRight: "8px"
          }}
        />
        <FormattedMessage id="settings.edit" />
      </div>
      {company.companies && !company.hasMoreItems &&
				<div
				  className={selectedView === "summary" ? "iconTypeGridForm right active" : "iconTypeGridForm right"}
				  onClick={() => changeView("summary")}
				>
				  <FontAwesomeIcon
				    icon={["far", "eye"]}
				    style={{
				      fontSize: 14,
				      marginRight: "8px"
				    }}
				  />
				  <FormattedMessage id="settings.summary" />
				</div>
      }
    </div>
  );
};

export default SettingsViewHandler;